import { FC, memo } from 'react'
import { Modal } from 'components/layouts/modal/modal'
import { SelectedEventRecordingTranscribe } from '../eventDetailPage/useEventDetailPage'
import { EditEventRecordingTranscribesEntryForm } from './components/editEventRecordingTranscribesEntryForm/editEventRecordingTranscribesEntryForm'

type EventRecordingTranscribesBulkUpdateSpeakersDialogProps = {
  title: string
  isOpen: boolean
  onSubmit: () => void
  onClose: () => void
  selectedTranscribes: SelectedEventRecordingTranscribe[]
  projectId: string | undefined
}

// 話者一括変更ダイアログ
export const EventRecordingTranscribesBulkUpdateSpeakersDialog: FC<EventRecordingTranscribesBulkUpdateSpeakersDialogProps> =
  memo((props) => {
    return (
      <Modal title={props.title} isOpen={props.isOpen} onClose={props.onClose}>
        <EditEventRecordingTranscribesEntryForm
          onSubmit={props.onSubmit}
          onClose={props.onClose}
          selectedTranscribes={props.selectedTranscribes.map((transcribe) => ({
            eventRecordingTranscribeId: transcribe.id,
            version: transcribe.version,
          }))}
          projectId={props.projectId}
        />
      </Modal>
    )
  })
